export enum ContactFormSourceType {
  MT4_DEMO = 'MT4 Demo',
  NEWSLETTER = 'USA_Weekly_Newsletter',
  PREMIUM_SERVICES = 'US_Premium_Services_Contact',
}

export interface ContactFormI {
  description: string;
  header: string;
  sourceType: ContactFormSourceType;
  usePhoneNumber?: boolean;
  phoneRequired?: boolean;
  privacyNoticeAboveMainCTA?: string;
  submitButtonText?: string;
  confirmationMessage?: string;
  phoneFieldHint?: string;
}
